"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.enumToOptions = exports.validateStrCoordinates = exports.latLngToMapCoordinate = exports.strippHtmlString = exports.calculatePeriodInDays = exports.canRespond = exports.getValueByPath = exports.richTextDefaultValue = exports.nullifyEmptyStringProperties = exports.getFileSize = exports.isRichTextEmpty = exports.richTextContentToPlainText = exports.parseRichTextValue = exports.isJsonStringArray = exports.isJsonString = void 0;
const draft_js_1 = require("draft-js");
const constants_1 = require("./constants");
const moment_1 = __importDefault(require("moment"));
const isJsonString = (str) => {
    if (typeof str !== 'string') {
        return false;
    }
    try {
        JSON.parse(str);
    }
    catch (e) {
        return false;
    }
    return true;
};
exports.isJsonString = isJsonString;
const isJsonStringArray = (str) => {
    try {
        const json = JSON.parse(str);
        return Array.isArray(json);
    }
    catch (e) {
        return false;
    }
};
exports.isJsonStringArray = isJsonStringArray;
const textToStateContent = (text) => {
    return JSON.stringify((0, draft_js_1.convertToRaw)(draft_js_1.ContentState.createFromText(text.toString())));
};
const parseRichTextValue = (value) => {
    return (0, exports.isJsonString)(value) ? value : textToStateContent(value);
};
exports.parseRichTextValue = parseRichTextValue;
const richTextContentToPlainText = (value) => {
    var _a, _b;
    if ((0, exports.isJsonString)(value)) {
        return (_b = (_a = JSON.parse(value)) === null || _a === void 0 ? void 0 : _a.blocks) === null || _b === void 0 ? void 0 : _b.reduce((text, block, index) => {
            return text + `${block.text}${index ? '<br>' : ''}`;
        }, '');
    }
    else {
        return value || '';
    }
};
exports.richTextContentToPlainText = richTextContentToPlainText;
const isRichTextEmpty = (value) => {
    return !(0, exports.richTextContentToPlainText)(value);
};
exports.isRichTextEmpty = isRichTextEmpty;
const getFileSize = (fileSize) => {
    let sizeIndex = 0;
    let floatFileSize = parseFloat(fileSize);
    while (floatFileSize > 1024 && sizeIndex < constants_1.SIZE_CONVERTER.length) {
        floatFileSize /= 1024;
        sizeIndex++;
    }
    return `${floatFileSize.toFixed(2)} ${constants_1.SIZE_CONVERTER[sizeIndex]}`;
};
exports.getFileSize = getFileSize;
/** Recursively nullify empty string properties **/
const nullifyEmptyStringProperties = (obj) => {
    return Object.entries(obj).reduce((acc, cur) => {
        const key = cur[0];
        const value = cur[1];
        if (Object.prototype.toString.call(value) === '[object Object]' && Object.keys(value).length) {
            return { ...acc, [key]: (0, exports.nullifyEmptyStringProperties)(value) };
        }
        return { ...acc, ...(value !== '' ? { [key]: value } : { [key]: null }) };
    }, {});
};
exports.nullifyEmptyStringProperties = nullifyEmptyStringProperties;
const richTextDefaultValue = () => JSON.stringify((0, draft_js_1.convertToRaw)(draft_js_1.EditorState.createEmpty().getCurrentContent()));
exports.richTextDefaultValue = richTextDefaultValue;
/**
 * Query object by string path and returns value
 * @param obj the object to query
 * @param path the path of property to get
 * @returns the resolved value
 */
const getValueByPath = (obj, path) => path.split('.').reduce((acc, cur) => acc && acc[cur], obj);
exports.getValueByPath = getValueByPath;
const canRespond = (type, addressTo, organizations) => {
    if (type === constants_1.CommentType.InformationRequest) {
        return (organizations === null || organizations === void 0 ? void 0 : organizations.some((o) => o.id === addressTo.id)) || false;
    }
    return true;
};
exports.canRespond = canRespond;
const calculatePeriodInDays = (firstDateInEpoch, secondDateInEpoch) => {
    const firstDate = moment_1.default.unix(firstDateInEpoch).startOf('day');
    const secondDate = moment_1.default.unix(secondDateInEpoch).startOf('day');
    return secondDate.diff(firstDate, 'days');
};
exports.calculatePeriodInDays = calculatePeriodInDays;
const strippHtmlString = (str) => str.replace(/(<([^>]+)>)/gi, '');
exports.strippHtmlString = strippHtmlString;
const latLngToMapCoordinate = (latlng) => {
    try {
        const parts = latlng.split(',');
        if (parts.length !== 2) {
            return undefined;
        }
        return {
            lat: parseFloat(parts[0].trim()),
            lng: parseFloat(parts[1].trim()),
        };
    }
    catch (_a) {
        return undefined;
    }
};
exports.latLngToMapCoordinate = latLngToMapCoordinate;
const validateStrCoordinates = (latlng) => {
    const mapCoordinate = (0, exports.latLngToMapCoordinate)(latlng);
    if (mapCoordinate) {
        const { lat, lng } = mapCoordinate;
        return !(isNaN(lat) || isNaN(lng) || lat < -90 || lat > 90 || lng < -180 || lng > 180);
    }
    return false;
};
exports.validateStrCoordinates = validateStrCoordinates;
const enumToOptions = (enumObject) => {
    return Object.values(enumObject).map((label, index) => {
        return {
            value: index,
            label,
        };
    });
};
exports.enumToOptions = enumToOptions;
